// Personal menu preferences: pinned tools and the sections left open.
// localStorage per the state rules; a blocked store degrades to defaults.

const PINS_KEY = "wb-nav:pins";
const OPEN_KEY = "wb-nav:open";

function readList(key: string): string[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((v): v is string => typeof v === "string")
      : [];
  } catch {
    return [];
  }
}

function writeList(key: string, values: ReadonlyArray<string>): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(values));
  } catch {
    // Storage blocked: the preference lives for the session only.
  }
}

export const readPins = (): string[] => readList(PINS_KEY);
export const writePins = (pins: ReadonlyArray<string>): void =>
  writeList(PINS_KEY, pins);

export const readOpenSections = (): string[] => readList(OPEN_KEY);
export const writeOpenSections = (ids: ReadonlyArray<string>): void =>
  writeList(OPEN_KEY, ids);

export function togglePin(pins: ReadonlyArray<string>, action: string): string[] {
  return pins.includes(action)
    ? pins.filter((p) => p !== action)
    : [...pins, action];
}

export function toggleOpen(open: ReadonlyArray<string>, id: string): string[] {
  return open.includes(id) ? open.filter((o) => o !== id) : [...open, id];
}
